import { createContext } from "react";

export const OrganizationContext = createContext(null);
export const ClientContext = createContext(null);
export const IntegrationContext = createContext(null);

export const ConfigurationContext = ({ children, integration, client }) => {
    return (
        <IntegrationContext.Provider value={integration}>
            <ClientContext.Provider value={client}>{children}</ClientContext.Provider>
        </IntegrationContext.Provider>
    );
};
